import React from 'react'

function TableHeader ({ children }) {
  return (
    <div className='table-header mb-4 flex justify-between sm:mb-8 group space-x-4'>
      {children}
    </div>
  )
}

export default TableHeader
